import { ApolloClient } from "@apollo/client";

import {
  GenerateDisputeNotesDTO,
  GetDisputeConfigDTO,
  RaiseDisputeDeductionDTO,
} from "@/core/dto/deduction/disputeDeduction";
import { GENERATE_DISPUTE_NOTES, GET_DISPUTE_CONFIG, RAISE_DEDUCTION_DISPUTE } from "@/core/graphql/deduction";
import {
  DisputeConfig,
  IDeductionDisputeRepository,
  IDeductionDisputeRepositoryResponse,
  IGenerateDisputeNotesRepositoryResponse,
  RaiseDisputeDeduction,
} from "@/core/repositories/deduction";

export class DeductionDisputeRepository implements IDeductionDisputeRepository {
  constructor(private readonly client: ApolloClient) {}

  async raiseDisputeDeduction(params: RaiseDisputeDeductionDTO): Promise<RaiseDisputeDeduction> {
    const { data } = await this.client.mutate<IDeductionDisputeRepositoryResponse>({
      mutation: RAISE_DEDUCTION_DISPUTE,
      variables: { params },
    });

    if (!data) {
      throw new Error("Failed to raise dispute deduction");
    }

    return data.disputeRequest;
  }

  async generateDisputeNotes(params: GenerateDisputeNotesDTO): Promise<string> {
    const { data } = await this.client.mutate<IGenerateDisputeNotesRepositoryResponse>({
      mutation: GENERATE_DISPUTE_NOTES,
      variables: { params },
    });

    const note = data?.generateDisputeNotes?.note;
    if (!note) {
      throw new Error("Failed to generate dispute notes");
    }

    return note;
  }

  async getDisputeConfig(params: GetDisputeConfigDTO): Promise<DisputeConfig> {
    const { data } = await this.client.query<DisputeConfig>({
      query: GET_DISPUTE_CONFIG,
      variables: { params },
    });

    if (!data) {
      throw new Error("Failed to get dispute types");
    }

    return data;
  }
}
